<script>
    import { page } from '$app/stores';

    import Button from '$lib/components/Button.svelte';

    export let selectedVariant = null;

    // Function transform the globalId to SimpleId
    const getSimpleId = (selectedVariant) => {
        if (selectedVariant?.id) {
            const expression = /gid:\/\/shopify\/ProductVariant\/(\d+)/;
            return expression.exec(selectedVariant?.id)?.[1];
        }
        return null;
    };

    // Reactively get convert the simpleId
    $: variantId = getSimpleId(selectedVariant);

    // Form post error and state handling
    let formState = null;
    let formErrors = [];

    const submitForm = async (data) => {
        formErrors = []; // Reset errors on new post
        formState = `submitting`;

        const response = await fetch(`/api/outofstock`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const responseData = await response.json();

        if (response.ok && responseData?.success === 1) {
            formState = `submitted`;
            return; // Break out of here now  before we throw some errors
        }

        // Catches errors from API and fetch/network
        const error = responseData?.error || 'An error occurred';
        formState = null; // reset form state so can retry
        formErrors = [...formErrors, error]; // Push errors
    };

    // Bound to the form
    const handleSubmit = (e) => {
        let data = {};
        const formData = new FormData(e.target);
        formData.forEach((value, key) => (data[key] = value));

        submitForm(data);
    };
</script>

<div class="flex min-h-[12rem] flex-col justify-center gap-4 text-center">
    {#key formState}
        {#if formState === 'submitting'}
            <p class="animate-pulse text-center">Submitting, please wait...</p>
        {:else if formState === 'submitted'}
            <div class="text-center">
                <p class="text-xl font-semibold dark:text-purple-300">Success!</p>
                <p class="py-3">We will email you as soon as we are Back in Stock!</p>
            </div>
        {:else}
            <p class="text-xl font-semibold dark:text-purple-300">Out of Stock</p>
            <p>Enter your email address and we will let you know when we're back in stock!</p>
            <form class="flex flex-col gap-4" on:submit|preventDefault={handleSubmit}>
                <input name="variant_id" type="hidden" value={variantId} />
                <input
                    name="destination"
                    type="email"
                    required
                    placeholder="enter email address"
                    autocomplete="email"
                    class="w-full rounded-md border border-color-text/10 bg-base-900 px-4 py-3 text-base text-color-text shadow-sm lg:col-span-9"
                    value={$page?.data?.user?.email || ''}
                />
                <Button style="Primary" type="submit">Email Me</Button>
            </form>
            {#if formErrors.length}{#each formErrors as error}<p class="my-3 rounded-md bg-red-200 px-3 py-2 text-gray-800">{error}</p>{/each}{/if}
        {/if}
    {/key}
</div>
